import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

/**
 *
 * @param {Object} params
 * @return {function(*)}
 */
// eslint-disable-next-line arrow-body-style
export const getManyUserPathways = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/userpathways`;
    let url;

    if (rest && rest.dispatchDisabled) {
        delete rest.dispatchDisabled;
        url = buildQueryString(rest, baseUrl);
        return VerbFetch(url);
    }

    url = buildQueryString(rest, baseUrl);
    return (dispatch) => {
        dispatch({
            type: ACTIONS.GET_MANY_USER_PATHWAYS_START
        });
        return VerbFetch(url).then((result) => {
            dispatch({
                type: ACTIONS.GET_MANY_USER_PATHWAYS_SUCCESS,
                payload: {
                    userPathways: result
                }
            });
            return result;
        });
    };
};

// eslint-disable-next-line arrow-body-style
export const getUserPathway = (params) => {
    const { userPathwayId, pathsContext } = params;
    const url = `${pathsContext.serverUrl}/userpathways/${userPathwayId}`;

    if (params && params.dispatchDisabled) {
        return VerbFetch(url);
    }

    return (dispatch) =>
        VerbFetch(url).then((result) => {
            dispatch({
                type: ACTIONS.GET_USER_PATHWAY_SUCCESS,
                payload: {
                    userPathway: result
                }
            });
            return result;
        });
};

// eslint-disable-next-line arrow-body-style
export const getUserPathwayComplete = (params) => {
    const { userPathwayId, pathsContext } = params;
    const url = `${pathsContext.serverUrl}/userpathways/${userPathwayId}/complete`;
    return VerbFetch(url);
};

export const postUserPathway = (params) => {
    const { body, pathsContext } = params;
    const fetchOptions = {
        method: 'POST',
        body
    };
    const url = `${pathsContext.serverUrl}/userpathways`;

    return (dispatch) =>
        VerbFetch(url, fetchOptions).then((body) => {
            dispatch({
                type: ACTIONS.POST_USER_PATHWAY_SUCCESS,
                payload: {
                    userPathway: body
                }
            });
            return body;
        });
};

export const putUserPathway = (params) => {
    const { userPathwayId, body, pathsContext } = params;
    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/userpathways/${userPathwayId}`, {
            method: 'PUT',
            body
        }).then((result) => {
            dispatch({
                type: ACTIONS.PUT_USER_PATHWAY_SUCCESS,
                payload: {
                    userPathway: result
                }
            });
            return result;
        });
};

export const deleteUserPathway = (params) => {
    const { userPathwayId, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.DELETE_USER_PATHWAY_START,
            payload: {
                userPathwayId
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/userpathways/${userPathwayId}`, {
            method: 'DELETE'
        }).then(() => {
            dispatch({
                type: ACTIONS.DELETE_USER_PATHWAY_SUCCESS,
                payload: {
                    userPathwayId
                }
            });
        });
    };
};

export const clearSearchedUserPathways = () => (dispatch) =>
    dispatch({
        type: ACTIONS.CLEAR_SEARCHED_USER_PATHWAYS
    });
